export const preload = ( filename, callback ) =>
    {
        const
            img = document.createElement( 'img' )
        
        img.onload = e => callback( img )
        img.onerror = e => callback( img )

        img.src = filename
    }